import * as React from 'react'
import {connect} from 'react-redux'
import ReactTable from 'react-table'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {nls} from '../../core/components/nls'
import TableSelector from '../../core/components/Tables/TableSelector'
import {DrawSource} from '../../core/enums/DrawSource'
import {
  IDataQueriesDispatcher,
  IFeatureTablesDispatcher,
  IMapDispatcher,
  IPopupDispatcher,
  ISingleViewDispatcher
} from '../../core/interfaces/dispatchers'
import {ITableProps} from '../../core/interfaces/models'
import {IDataQueries, IFeatureLayerInfos, ISelectedFeature} from '../../core/interfaces/reducers'
import {getMapService} from '../../core/reducers/map'
import {appDataQueriesDispatcher} from '../../dispatchers/appDataQueriesDispatcher'
import {appFeatureTablesDispatcher} from '../../dispatchers/appFeatureTablesDispatcher'
import {appMapDispatcher} from '../../dispatchers/appMapDispatcher'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {appSingleViewDispatcher} from '../../dispatchers/appSingleViewDispatcher'
import {IAppStore, IUserInfo} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import AppDataFilters from '../DataFilters/AppDataFilters'
import AppReadOnlyEditSplitter from '../FeatureViews/AppReadOnlyEditSplitter'
import {appPropsProvider} from './AppPropsProvider'

export interface ParentProps {
  hideNavigation?: boolean
  hideFilters?: boolean
}
export interface OwnProps {
  visibleTables: {[key: string]: string}
  tabInfos: {[id: string]: ITableProps}
  mobile: boolean
  loading: boolean
  layerInfos: IFeatureLayerInfos
  userInfo: IUserInfo
  selectedFeature?: ISelectedFeature
  long: boolean
  dataQueries: IDataQueries
}

export interface DispatchProps
  extends IFeatureTablesDispatcher, IMapDispatcher, IPopupDispatcher, IDataQueriesDispatcher, ISingleViewDispatcher {}

type Props = OwnProps & DispatchProps & ParentProps

interface State {}

class SingleTableContainer extends React.Component<Props, State> {
  forceRefresh = false
  alreadyCreated: {[key: string]: string} = {}
  componentDidMount() {
    const selections = Object.keys(this.props.visibleTables)
    if (selections.length > 0 && this.props.tabInfos[selections[0]]) {
      this.props.refrashTable(selections[0])
    } else {
      this.createOrRefresh(this.props)
    }
  }

  createOrRefresh(props: Props) {
    const infos: IFeatureLayerInfos = {}
    for (const i in props.layerInfos) {
      if (!props.layerInfos[i].sourceDescription.noRegister) {
        infos[i] = props.layerInfos[i]
      }
    }
    const selections = Object.keys(props.visibleTables)
    const infosKeys = Object.keys(infos)
    if (selections.length > 0) {
      if (props.tabInfos[selections[0]]) {
        if (!this.forceRefresh) {
          props.refrashTable(selections[0])
          this.forceRefresh = true
        }
      } else if (infos[selections[0]] && !this.alreadyCreated[selections[0]]) {
        this.alreadyCreated[selections[0]] = selections[0]
        this.forceRefresh = true
        this.setFeatureTable(props, selections[0])
      }
    } else if (infosKeys.length > 0) {
      props.setTablesVisibility({[infosKeys[0]]: infosKeys[0]})
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.visibleTables !== this.props.visibleTables || prevProps.layerInfos !== this.props.layerInfos) {
      this.createOrRefresh(this.props)
    }
  }

  setFeatureTable(props: Props, id: string) {
    const info = props.layerInfos[id]
    const tprops = appPropsProvider.convertToReduxAsync(
      appPropsProvider.getReduxTableProps(props.layerInfos[id], props),
      props
    )
    props.setFeatureTables([tprops])
  }

  getOnSelectaedTableChange(): (id: string) => void {
    return (id: string) => {
      if (!this.props.tabInfos[id]) {
        this.forceRefresh = true
        this.setFeatureTable(this.props, id)
      } else {
        this.props.refrashTable(id)
      }
      this.props.setTablesVisibility({[id]: id})
    }
  }
  protected renderNavigation(): JSX.Element | null {
    const infos: IFeatureLayerInfos = {}
    for (const i in this.props.layerInfos) {
      if (!this.props.layerInfos[i].sourceDescription.noRegister) {
        infos[i] = this.props.layerInfos[i]
      }
    }
    return (
      <TableSelector
        onChange={this.getOnSelectaedTableChange()}
        layerInfos={infos}
        visibleTables={this.props.visibleTables}
      />
    )
  }

  protected renderFilters(): JSX.Element | null {
    const selections = Object.keys(this.props.visibleTables)
    if (selections.length > 0 && this.props.layerInfos[selections[0]]) {
      const dataQuery = this.props.dataQueries[selections[0]]
      return (
        <AppDataFilters
          expandable={!this.props.long}
          layerInfo={this.props.layerInfos[selections[0]]}
          defaultControlQueries={dataQuery ? dataQuery.controledQueries : {}}
          setQueries={this.props.setQueries}
        />
      )
    }
    return null
  }

  protected renderTable(): JSX.Element | null {
    const selections = Object.keys(this.props.visibleTables)
    if (selections.length > 0) {
      const tableInfo = this.props.tabInfos[selections[0]]

      if (tableInfo) {
        if (tableInfo.error) {
          return <div className="table-error">{tableInfo.error.message}</div>
        }
        return (
          <React.Fragment>
            <OverlayLoader size="60px" show={this.props.tabInfos[selections[0]].loading} />
            <ReactTable key={selections[0]} {...this.props.tabInfos[selections[0]]} />
          </React.Fragment>
        )
      }
      return null
    }
    return null
  }
  showOnMapButton(): JSX.Element {
    return (
      <button
        type="button"
        className="button margin"
        style={{}}
        onClick={() => {
          if (
            this.props.selectedFeature &&
            this.props.selectedFeature.feature &&
            this.props.selectedFeature.feature.getGeometry()
          ) {
            getMapService().panTo(this.props.selectedFeature.feature.getGeometry())
          }
          if (getMapService().getZoom() < 18) {
            getMapService().setZoom(18)
          }
          getMapService().drawing.mark([this.props.selectedFeature!.feature], DrawSource.Select)
        }}
      >
        Покажи на картата
      </button>
    )
  }
  getDetailView(): JSX.Element | null {
    const layerInfo = this.props.selectedFeature && this.props.layerInfos[this.props.selectedFeature.id]
    const isEditable =
      !!this.props.selectedFeature &&
      !!layerInfo &&
      (!layerInfo!.sourceDescription.readOnly || layerInfo!.sourceDescription.id == appConfig.reg.plan.planUrl) &&
      !!this.props.userInfo.user &&
      (this.props.userInfo.user.isAdmin ||
        (appConfig.reg.regrelated.indexOf(layerInfo!.sourceDescription.id) != -1 &&
          this.props.userInfo.user.isRegAdmin) ||
        (appConfig.misc.miscrelated.indexOf(layerInfo!.sourceDescription.id) != -1 &&
          this.props.userInfo.user.isCadAdmin) ||
        (appConfig.und.undrelated.indexOf(layerInfo!.sourceDescription.id) != -1 &&
          this.props.userInfo.user.isUndAdmin))

    return this.props.selectedFeature && layerInfo ? (
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          zIndex: 9,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{display: 'flex', backgroundColor: 'gainsboro', justifyContent: 'space-between'}}>
          <button
            type="button"
            className="button margin"
            onClick={() => {
              if (layerInfo!.sourceDescription.noRegister) this.createOrRefresh(this.props)
              setTimeout(() => {
                getMapService().drawing.unMark(DrawSource.Select)
                this.props.removeSelectedFeature()
              }, 120)
            }}
          >
            {'<< Обратно към таблицата'}
          </button>{' '}
          :{this.showOnMapButton()}
        </div>
        {this.props.selectedFeature.loading ? (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={true}></OverlayLoader>
          </div>
        ) : (
          <div style={{overflow: 'auto'}}>
            <AppReadOnlyEditSplitter
              feature={this.props.selectedFeature.feature}
              layerInfo={layerInfo}
              isEditable={() => isEditable} // if its reg related and the user is reg admin
              editAgain={f => f}
            />
          </div>
        )}
      </div>
    ) : null
  }

  getTableControls(): JSX.Element {
    const withNavi = !this.props.hideNavigation && Object.keys(this.props.layerInfos).length > 1
    return (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          maxWidth: this.props.long ? '300px' : '',
          overflow: this.props.long ? 'auto' : ''
        }}
      >
        {withNavi ? this.renderNavigation() : null}
        {this.props.hideFilters ? null : this.renderFilters()}
      </div>
    )
  }

  tryGetTable(): JSX.Element {
    return (
      <div className="table-strech">
        {this.props.loading ? (
          <React.Fragment>
            <OverlayLoader size="60px" show={this.props.loading} />
            {this.renderTable()}
          </React.Fragment>
        ) : Object.keys(this.props.tabInfos).length > 0 ? (
          this.renderTable()
        ) : (
          <div className="table-no-results">{nls.table.noResults}</div>
        )}
      </div>
    )
  }

  render() {
    return (
      <div
        style={{
          height: '100%',
          position: 'relative',
          display: 'flex',
          flexDirection: this.props.long && !this.props.hideFilters ? 'row' : 'column'
        }}
      >
        {this.getDetailView()}
        {this.getTableControls()}
        {this.tryGetTable()}
      </div>
    )
  }
}
export const mapStateToProps = (state: IAppStore) => ({
  visibleTables: state.data.visibleTables,
  tabInfos: state.data.featureTables,
  mobile: state.application.mobile,
  loading: state.data.loading,
  layerInfos: state.layerInfos.featureLayerInfos,
  userInfo: state.userInfo,
  selectedFeature: state.data.singleViewSelectedFeature,
  long: state.sidebar.long,
  dataQueries: state.dataQueries
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {
  ...appFeatureTablesDispatcher,
  ...appMapDispatcher,
  ...appPopupDispatcher,
  ...appDataQueriesDispatcher,
  ...appSingleViewDispatcher
})(SingleTableContainer)
